<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Parâm. de Produtividade
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  consultar
        |  e
        strong  alterar
        |  os parâmetros de produtividade do departamento em
        strong  Configurações → Parâm. de Produtividade
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Produtividade parâmetros → Exibir
        | . Para gravar alterações, use também
        strong  Sistema → Produtividade parâmetros → Alterar
        | .

      h5.h5 1. Abrir Parâm. de Produtividade
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Clique em
          strong  Parâm. de Produtividade
          | .
      p
        | Não há listagem: a tela carrega o conjunto único de parâmetros atuais.

      h5.h5 2. Metas, percentuais e regras
      figure.manual-figure
        img(:src="imgParams" alt="Parâmetros de produtividade")
      ol
        li Em metas e pontos, ajuste meta mínima/máxima individual, meta coletiva,
          |  pontos da meta coletiva, início e máximo da pontuação extraordinária (super meta).
        li Em percentuais sobre o salário base, configure máximos individual e coletivo,
          |  fração e percentual por fração da meta extraordinária.
        li Em regras operacionais, informe pontos por hora extra, local fechado,
          |  reabrir OS-m, concluir fora do prazo, meses/pontos de experiência e meses
          |  para média no afastamento.

      h5.h5 3. Cadastros auxiliares e multiplicadores
      ol
        li Preencha o
          strong  Nome do secretário
          | , selecione
          strong  Fiscais internos
          |  e mantenha os
          strong  Membros da Comissão
          |  (nome e matrícula; botão Novo membro).
        li Em
          strong  Fator de Multiplicação
          |  (valores dos documentos), adicione regras com valor inicial, valor final
          |  e multiplicador. Só a última regra edita o valor final; use ∞ para o máximo.
        li Clique em
          strong  Salvar
          |  no rodapé.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgParams: require("@/assets/manuais/42-config-produtividade-params.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
